import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../../../store/actions/churgerBuilderActions';
import * as p from '../ChurgerImgRefs/ChurgerPicRefs';

import ChurgerControlItem from './ChurgerControlItem';

// export all add and remove ings?
// e. prevent default on those functions?

// move pic refs to control item?
// move items arrays to separate comp?

export default React.memo(function ChurgerControls() {
	const dispatch = useDispatch();

	const ings = useSelector((state) => {
		return state.ingredients;
	});

	const cat = useSelector((state) => {
		return state.category;
	});

	const meme = useSelector((state) => {
		return state.meme;
	});

	const [prevState, setPrevState] = useState(cat === 0 ? true : false);

	let header =
		cat === 0 ? (
			<p>Pick a bun!</p>
		) : cat === 1 ? (
			<p>Grab a meat or two!</p>
		) : cat === 2 ? (
			<p>Choose up to 4 toppings!</p>
		) : cat === 3 ? (
			<p>Super soak that hoe!</p>
		) : cat === 4 ? (
			<p>
				Type something! <br /> Then screenshot and post it, pussy!
			</p>
		) : (
			<p>Pick something!</p>
		);

	const buns = [
		{ label: 'Sesame', type: 'sesame', pic: p.sesame },
		{ label: 'Plain', type: 'plain', pic: p.plain },
		{ label: 'Toast', type: 'toast', pic: p.toast },
		{ label: 'Torta', type: 'torta', pic: p.torta },
		{ label: 'Hot Dog', type: 'hotDog', pic: p.hotDog },
		{ label: 'Maxi Pad', type: 'maxiPad', pic: p.maxiPad },
		{ label: 'Toilet Paper', type: 'toiletPaper', pic: p.toiletPaper },
		{ label: 'Vegan', type: 'vegan', pic: p.vegan },
	];

	const meats = [
		{ label: 'Red Meat', type: 'redMeat', pic: p.redMeat },
		{ label: 'Brown Meat', type: 'brownMeat', pic: p.brownMeat },
		{ label: 'Crispy Chimken', type: 'crispyChimken', pic: p.crispyChimken },
		{ label: 'Fresh Chimken', type: 'freshChimken', pic: p.freshChimken },
		{ label: 'More Bun', type: 'moreBun', pic: p.moreBun },
		{ label: 'Fisch', type: 'fisch', pic: p.fisch },
		{ label: 'Mushrooms', type: 'mushrooms', pic: p.mushrooms },
		{ label: 'Mitch McConnell', type: 'mitchMcConnell', pic: p.mitchMcConnell },
	];

	const toppings = [
		{ label: 'Tomato', type: 'tomato', pic: p.tomato },
		{ label: 'Lettuce', type: 'lettuce', pic: p.lettuce },
		{ label: 'Onion', type: 'onion', pic: p.onion },
		{
			label: 'Flavor of the Month',
			type: 'flavorOfTheMonth',
			pic: p.flavorOfTheMonth,
		},
		{ label: 'Cheese', type: 'cheese', pic: p.cheese },
		{ label: 'Bacon', type: 'bacon', pic: p.bacon },
		{ label: 'Barnacles', type: 'barnacles', pic: p.barnacles },
		{ label: 'Pennies', type: 'pennies', pic: p.pennies },
	];

	const sauces = [
		{ label: 'Ketchup', type: 'ketchup', pic: p.ketchup },
		{ label: 'Musturd', type: 'musturd', pic: p.musturd },
		{ label: 'Mayo', type: 'mayo', pic: p.mayo },
		{ label: 'Clown Tears', type: 'clownTears', pic: p.clownTears },
		{ label: 'Periodt Blod', type: 'periodtBlod', pic: p.periodtBlod },
		{ label: 'Blood Diamonds', type: 'bloodDiamonds', pic: p.bloodDiamonds },
		{ label: 'Bukkake Brunch', type: 'bukkakeBrunch', pic: p.bukkakeBrunch },
		{ label: 'Sewage', type: 'sewage', pic: p.sewage },
	];

	const inputs = [
		{
			placeholder: meme.name1,
			label: 'name1',
			type: 'blank',
		},
		{
			placeholder: meme.name2,
			label: 'name2',
			type: 'blank',
		},
		{
			placeholder: meme.circ1,
			label: 'circ1',
			type: 'blank',
		},
		{
			placeholder: meme.circ2_1,
			label: 'circ2_1',
			type: 'blank',
		},
		{
			placeholder: meme.circ2_2,
			label: 'circ2_2',
			type: 'blank',
		},
		{
			placeholder: meme.circ3,
			label: 'circ3',
			type: 'blank',
		},
		{
			placeholder: meme.smolText,
			label: 'smolText',
			type: 'blank',
		},
		{ label: 'blank', type: 'blank' },
	];

	const currentIngList = [buns, meats, toppings, sauces, inputs];

	let items = currentIngList[cat];

	const onIngredientAdded = (ingName) => {
		dispatch(actions.addIngredient(ingName));
		if (ingName === 'freshChimken') dispatch(actions.setFXPlaying('bKok'));
		else if (ingName === 'bloodDiamonds')
			dispatch(actions.setFXPlaying('breakingGlass'));
		else if (ingName === 'pennies') dispatch(actions.setFXPlaying('coins'));
		else if (ingName === 'bacon') dispatch(actions.setFXPlaying('copSiren'));
		else if (
			ingName === 'toast' ||
			ingName === 'crispyChimken' ||
			ingName === 'lettuce' ||
			ingName === 'onion'
		)
			dispatch(actions.setFXPlaying('crunch'));
		else if (ingName === 'UNUSED')
			dispatch(actions.setFXPlaying('crunchApple'));
		else if (ingName === 'clownTears')
			dispatch(actions.setFXPlaying('ericIngredients'));
		else if (ingName === 'toiletPaper') dispatch(actions.setFXPlaying('fart'));
		else if (ingName === 'mayo') dispatch(actions.setFXPlaying('hankBwa'));
		else if (ingName === 'bukkakeBrunch')
			dispatch(actions.setFXPlaying('hankBwukkake'));
		else if (ingName === 'periodtBlod')
			dispatch(actions.setFXPlaying('hankPeriod'));
		else if (ingName === 'sewage') dispatch(actions.setFXPlaying('hideyHo'));
		else if (ingName === 'mushrooms')
			dispatch(actions.setFXPlaying('marsVolta'));
		else if (ingName === 'torta') dispatch(actions.setFXPlaying('jarabe'));
		else if (ingName === 'mitchMcConnell')
			dispatch(actions.setFXPlaying('mitch'));
		else if (ingName === 'vegan')
			dispatch(actions.setFXPlaying('ripCardboard'));
		else if (ingName === 'fisch') dispatch(actions.setFXPlaying('seagulls'));
		else if (ingName === 'bacon')
			dispatch(actions.setFXPlaying('seedsDropping'));
		else if (ingName === 'onion') dispatch(actions.setFXPlaying('slipPaper'));
		else if (
			ingName === 'maxiPad' ||
			ingName === 'brownMeat' ||
			ingName === 'flavorOfTheMonth'
		)
			dispatch(actions.setFXPlaying('splatDry'));
		else if (
			ingName === 'redMeat' ||
			ingName === 'tomato' ||
			ingName === 'cheese'
		)
			dispatch(actions.setFXPlaying('splatMoist'));
		else if (ingName === 'UNUSED') dispatch(actions.setFXPlaying('splatWet'));
		else if (ingName === 'barnacles')
			dispatch(actions.setFXPlaying('spongebobCredits'));
		else if (ingName === 'ketchup')
			dispatch(actions.setFXPlaying('squirtLong'));
		else if (ingName === 'musturd')
			dispatch(actions.setFXPlaying('squirtShort'));
		else if (
			ingName === 'sesame' ||
			ingName === 'plain' ||
			ingName === 'moreBun'
		)
			dispatch(actions.setFXPlaying('thunkHeavyBox'));
		else if (ingName === 'hotDog') dispatch(actions.setFXPlaying('thunkPipe'));
		else {
			dispatch(actions.setFXPlaying('fart'));
		}
	};

	const onIngredientRemoved = (ingName) => {
		dispatch(actions.removeIngredient(ingName));
		dispatch(actions.setFXPlaying('pop'));
	};

	const lessDisabledInfo = { ...ings };

	for (let key in lessDisabledInfo) {
		lessDisabledInfo[key] = lessDisabledInfo[key] < 1;
	}

	let moreDisabledInfo = { ...ings, blank: 1 };

	let newMDI = {
		buns: [
			moreDisabledInfo.sesame,
			moreDisabledInfo.plain,
			moreDisabledInfo.toast,
			moreDisabledInfo.torta,
			moreDisabledInfo.hotDog,
			moreDisabledInfo.maxiPad,
			moreDisabledInfo.toiletPaper,
			moreDisabledInfo.vegan,
		],
		meats: [
			moreDisabledInfo.redMeat,
			moreDisabledInfo.brownMeat,
			moreDisabledInfo.crispyChimken,
			moreDisabledInfo.freshChimken,
			moreDisabledInfo.moreBun,
			moreDisabledInfo.fisch,
			moreDisabledInfo.mushrooms,
			moreDisabledInfo.mitchMcConnell,
		],
		toppings: [
			moreDisabledInfo.tomato,
			moreDisabledInfo.lettuce,
			moreDisabledInfo.onion,
			moreDisabledInfo.flavorOfTheMonth,
			moreDisabledInfo.cheese,
			moreDisabledInfo.bacon,
			moreDisabledInfo.barnacles,
			moreDisabledInfo.pennies,
		],
	};

	if (newMDI.buns.includes(1)) {
		moreDisabledInfo = {
			...moreDisabledInfo,
			sesame: 1,
			plain: 1,
			toast: 1,
			torta: 1,
			hotDog: 1,
			maxiPad: 1,
			toiletPaper: 1,
			vegan: 1,
		};
	}

	let meatsSum = newMDI.meats.reduce((a, b) => {
		return a + b;
	});
	if (meatsSum > 1) {
		moreDisabledInfo = {
			...moreDisabledInfo,
			redMeat: 1,
			brownMeat: 1,
			crispyChimken: 1,
			freshChimken: 1,
			moreBun: 1,
			fisch: 1,
			mushrooms: 1,
			mitchMcConnell: 1,
		};
	}

	let toppingsSum = newMDI.toppings.reduce((a, b) => {
		return a + b;
	});
	if (toppingsSum > 3) {
		moreDisabledInfo = {
			...moreDisabledInfo,
			tomato: 1,
			lettuce: 1,
			onion: 1,
			cheese: 1,
			flavorOfTheMonth: 1,
			bacon: 1,
			barnacles: 1,
			pennies: 1,
		};
	}

	const prevHandler = () => {
		if (cat > 0) dispatch(actions.setCategory(cat - 1));
		if (cat === 1) {
			setPrevState(true);
		} else {
			setPrevState(false);
		}
	};

	const nextHandler = () => {
		if (cat < 4) {
			dispatch(actions.setCategory(cat + 1));
		}
		if (cat === 4) {
			if (window.confirm('Are you sure?')) {
				if (window.confirm('Are you really really sure?')) {
					if (
						window.confirm(
							"You can't back out now bro, I hope you're ready to cough up the fucking money!"
						)
					) {
						window.open(
							'https://www.mcdondals.net/products/beesechurger-hoodie'
						);
					}
				}
			}
		}
		setPrevState(false);
	};

	const addTopBun = useCallback(() => {
		if (
			!ings.sesameTop &&
			!ings.plainTop &&
			!ings.toastTop &&
			!ings.tortaTop &&
			!ings.hotDogTop &&
			!ings.maxiPadTop &&
			!ings.toiletPaperTop &&
			!ings.veganTop
		) {
			if (ings.sesame) dispatch(actions.addIngredient('sesameTop'));
			else if (ings.plain) dispatch(actions.addIngredient('plainTop'));
			else if (ings.toast) dispatch(actions.addIngredient('toastTop'));
			else if (ings.torta) dispatch(actions.addIngredient('tortaTop'));
			else if (ings.hotDog) dispatch(actions.addIngredient('hotDogTop'));
			else if (ings.maxiPad) dispatch(actions.addIngredient('maxiPadTop'));
			else if (ings.toiletPaper)
				dispatch(actions.addIngredient('toiletPaperTop'));
			else if (ings.vegan) dispatch(actions.addIngredient('veganTop'));
		}
	}, [ings, dispatch]);

	const removeTopBun = useCallback(() => {
		if (
			ings.sesameTop ||
			ings.plainTop ||
			ings.toastTop ||
			ings.tortaTop ||
			ings.hotDogTop ||
			ings.maxiPadTop ||
			ings.toiletPaperTop ||
			ings.veganTop
		) {
			if (ings.sesameTop) dispatch(actions.removeIngredient('sesameTop'));
			else if (ings.plainTop) dispatch(actions.removeIngredient('plainTop'));
			else if (ings.toastTop) dispatch(actions.removeIngredient('toastTop'));
			else if (ings.tortaTop) dispatch(actions.removeIngredient('tortaTop'));
			else if (ings.hotDogTop) dispatch(actions.removeIngredient('hotDogTop'));
			else if (ings.maxiPadTop)
				dispatch(actions.removeIngredient('maxiPadTop'));
			else if (ings.toiletPaperTop)
				dispatch(actions.removeIngredient('toiletPaperTop'));
			else if (ings.veganTop) dispatch(actions.removeIngredient('veganTop'));
		}
	}, [ings, dispatch]);

	useEffect(() => (cat > 2 ? addTopBun() : undefined), [cat, addTopBun]);

	useEffect(() => (cat < 3 ? removeTopBun() : undefined), [cat, removeTopBun]);

	let nextLabel = cat === 4 ? 'Pay' : 'Next';

	let prevNextHeight = cat === 4 ? '32%' : '';

	return (
		<div className="CControls">
			<div className="CCHeader">{header}</div>
			{items.map((ctrl) => (
				<ChurgerControlItem
					cat={cat}
					key={ctrl.label}
					label={ctrl.label}
					pic={ctrl.pic}
					added={() => onIngredientAdded(ctrl.type)}
					removed={() => onIngredientRemoved(ctrl.type)}
					lessDisabled={lessDisabledInfo[ctrl.type]}
					moreDisabled={moreDisabledInfo[ctrl.type]}
					placeholder={ctrl.placeholder}
				/>
			))}

			<button
				className="PrevNext"
				style={{ height: prevNextHeight }}
				onClick={prevHandler}
				disabled={prevState}
			>
				Prev
			</button>
			<button
				className="PrevNext"
				style={{ height: prevNextHeight }}
				onClick={nextHandler}
			>
				{nextLabel}
			</button>
		</div>
	);
});
